import {useContext, useEffect, useState} from "react";
import Map, { Marker, Popup, useMap} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import useSupercluster from "use-supercluster";
import mapboxgl from "mapbox-gl"


import Pin from './MariupolPin';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import log from "tailwindcss/lib/util/log";
import {LanguageContext} from "../../App";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const TOKEN = 'pk.eyJ1IjoidGltb2ZlamFuZHJvcG92IiwiYSI6ImNsMG1zN3pyNTE1eWczY25zd2ExcHNkd3EifQ.bAxtoJwQXLx_e2ZWpYa1fQ';

// // eslint-disable-next-line import/no-webpack-loader-syntax
// mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;



const MapView = ({points, clicked, setClicked}) => {
    const {language} = useContext(LanguageContext)
    const navigate = useNavigate()
    const {main_map} = useMap();
    const [viewport, setViewport] = useState({
        latitude: 64.17,
        longitude: 105.13,
        zoom: 2,
        bearing: 0,
        pitch: 0
    });

    const params = useParams()

    const [isPoint, setIsPoint] = useState(false)

    const [hover, setHover] = useState({lon: 0, lat: 0, title: ''})
    const [isHover, setIsHover] = useState(false)
    const set_hover = (point) => {
        setHover({
                lon: point.geometry.coordinates[0],
                lat: point.geometry.coordinates[1],
                title: point.properties.title
        })
        setIsHover(true)
    }

    const markclick = (cluster) => {
        // e.preventDefault()
        setIsPoint(true)
        setClicked(cluster)
    }

    const mapclick = () => {
        if (isPoint) {
            setIsPoint(false)
        } else {
            if (params.slug) {
                setClicked({
                    properties: {
                        id: null
                    }
                })
                if (language.name === 'en') {
                    navigate('/en')
                } else {
                    navigate('/')
                }
            }
        }
    }

    useEffect(() => {
        if (main_map && clicked?.geometry?.coordinates) {
            if (viewport.zoom > 10){
                main_map.flyTo({center:clicked.geometry.coordinates})
            } else {
                main_map.flyTo({center:clicked.geometry.coordinates, zoom:10})
            }

        }

    }, [clicked])


    const bounds = main_map ? main_map
            .getMap()
            .getBounds()
            .toArray()
            .flat()
        : null;

    const {clusters, supercluster} = useSupercluster({
        points,
        bounds,
        zoom: viewport.zoom,
        options: {radius: 40, maxZoom: 10}
    });

    return (
        <div className='grow'>
            <Map
                {...viewport}
                id="main_map"
                mapboxAccessToken={TOKEN}
                mapStyle="mapbox://styles/timofejandropov/cl21rmet9008g14lfeih5jwxd"
                onMove={evt => setViewport(evt.viewState)}
                onClick = {mapclick}
            >
                { isHover &&
                    <Popup
                        longitude={hover.lon}
                        latitude={hover.lat}
                        closeOnClick={false}
                        closeButton={false}
                    >
                        <div className="">
                            <span>{hover.title}</span>
                        </div>
                    </Popup>
                }

                { clusters.map((cluster,index) => {
                    const [longitude, latitude] = cluster.geometry.coordinates;
                    const {
                        cluster: isCluster,
                        point_count: pointCount
                    } = cluster.properties;

                    if (isCluster) {
                        return (
                            <Marker
                                key={'cluster-' + (cluster.id)}
                                latitude={latitude}
                                longitude={longitude}
                                anchor="top"
                            >
                                <div
                                    className="rounded-full bg-gradient-to-b from-red-500 to-red-900 flex items-baseline
                                    hover:cursor-pointer"
                                    style={{
                                        width: `${35 + (pointCount / points.length) * 20}px`,
                                        height: `${35 + (pointCount / points.length) * 20}px`
                                    }}
                                    onClick={() => {
                                        const expansionZoom = Math.min(
                                            supercluster.getClusterExpansionZoom(cluster.id),
                                            20
                                        );
                                        main_map.flyTo({center: [longitude, latitude], zoom:expansionZoom});
                                    }}
                                >
                                    <span className='m-auto text-white'>
                                        { pointCount }
                                    </span>
                                </div>
                            </Marker>
                        );
                    }

                    return (
                        <Marker
                            key={'id-'+index}
                            latitude={latitude}
                            longitude={longitude}
                            anchor="top"
                            onClick={() => markclick(cluster)}

                        >
                            <Pin clicked={clicked} point={cluster} set_hover={set_hover} setIsHover={setIsHover} />
                        </Marker>
                    );
                })}

            </Map>
        </div>
    )
}

export default MapView